// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TargetShowcase_TargetShowcase__rLeVE {
  overflow-y: scroll;
  position: relative;
  height: 72vh;
  padding: 24px;
  background: #F0F2F5;
}
.TargetShowcase_TargetShowcase__rLeVE .TargetShowcase_content__\\+AhSq {
  background: #ffffff;
  padding: 16px 24px;
}
@media screen and (max-width: 2600px) {
  .TargetShowcase_TargetShowcase__rLeVE .TargetShowcase_content__\\+AhSq .TargetShowcase_nameCol__j-6Eo, .TargetShowcase_TargetShowcase__rLeVE .TargetShowcase_content__\\+AhSq .TargetShowcase_nameCol__j-6Eo.TargetShowcase_nameColContent__7qMq8 {
    max-width: 190px;
  }
}
@media screen and (max-width: 1750px) {
  .TargetShowcase_TargetShowcase__rLeVE .TargetShowcase_content__\\+AhSq .TargetShowcase_nameCol__j-6Eo, .TargetShowcase_TargetShowcase__rLeVE .TargetShowcase_content__\\+AhSq .TargetShowcase_nameCol__j-6Eo.TargetShowcase_nameColContent__7qMq8 {
    max-width: 170px;
  }
}
@media screen and (max-width: 1550px) {
  .TargetShowcase_TargetShowcase__rLeVE .TargetShowcase_content__\\+AhSq .TargetShowcase_nameCol__j-6Eo, .TargetShowcase_TargetShowcase__rLeVE .TargetShowcase_content__\\+AhSq .TargetShowcase_nameCol__j-6Eo.TargetShowcase_nameColContent__7qMq8 {
    max-width: 160px;
  }
}
@media screen and (max-width: 1450px) {
  .TargetShowcase_TargetShowcase__rLeVE .TargetShowcase_content__\\+AhSq .TargetShowcase_nameCol__j-6Eo, .TargetShowcase_TargetShowcase__rLeVE .TargetShowcase_content__\\+AhSq .TargetShowcase_nameCol__j-6Eo.TargetShowcase_nameColContent__7qMq8 {
    max-width: 130px;
  }
}
@media screen and (max-width: 1400px) {
  .TargetShowcase_TargetShowcase__rLeVE .TargetShowcase_content__\\+AhSq .TargetShowcase_nameCol__j-6Eo, .TargetShowcase_TargetShowcase__rLeVE .TargetShowcase_content__\\+AhSq .TargetShowcase_nameCol__j-6Eo.TargetShowcase_nameColContent__7qMq8 {
    max-width: 120px;
  }
}
.TargetShowcase_TargetShowcase__rLeVE .TargetShowcase_content__\\+AhSq .TargetShowcase_nameCol__j-6Eo {
  min-width: 100px;
}
.TargetShowcase_TargetShowcase__rLeVE .TargetShowcase_content__\\+AhSq .TargetShowcase_nameCol__j-6Eo .TargetShowcase_nameColContent__7qMq8 {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.TargetShowcase_TargetShowcase__rLeVE .TargetShowcase_addRowBtn__R9EtY {
  margin-top: 16px;
  width: 100%;
  background: #91DAD3 !important;
  color: #00A899;
}

.TargetShowcase_TargetShowcase__rLeVE::-webkit-scrollbar {
  width: 4px;
  height: 4px;
}

.TargetShowcase_TargetShowcase__rLeVE::-webkit-scrollbar-thumb {
  background-color: #04867a;
  border-radius: 50px;
}

.TargetShowcase_TargetShowcase__rLeVE::-webkit-scrollbar-track {
  background: #e2e4e7;
}`, "",{"version":3,"sources":["webpack://./src/components/modules/tables/components/DocumentProcessing/TargetShowcase/TargetShowcase.module.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;AACF;AACE;EACE,mBAAA;EACA,kBAAA;AACJ;AACM;EADF;IAEI,gBAAA;EAEN;AACF;AADM;EAJF;IAKI,gBAAA;EAIN;AACF;AAHM;EAPF;IAQI,gBAAA;EAMN;AACF;AAJM;EAXF;IAYI,gBAAA;EAON;AACF;AANM;EAdF;IAeI,gBAAA;EASN;AACF;AALI;EACE,gBAAA;AAON;AALM;EACE,uBAAA;EACA,gBAAA;EACA,mBAAA;AAOR;AAFE;EACE,gBAAA;EACA,WAAA;EAEA,8BAAA;EACA,cAAA;AAGJ;;AACA;EACE,UAAA;EACA,WAAA;AAEF;;AACA;EACE,yBAAA;EACA,mBAAA;AAEF;;AACA;EACE,mBAAA;AAEF","sourcesContent":[".TargetShowcase {\n  overflow-y: scroll;\n  position: relative;\n  height: 72vh;\n  padding: 24px;\n  background: #F0F2F5;\n\n  .content {\n    background: #ffffff;\n    padding: 16px 24px;\n    .nameCol, .nameCol.nameColContent {\n      @media screen and (max-width: 2600px) {\n        max-width: 190px;\n      }\n      @media screen and (max-width: 1750px) {\n        max-width: 170px;\n      }\n      @media screen and (max-width: 1550px) {\n        max-width: 160px;\n      }\n\n      @media screen and (max-width: 1450px) {\n        max-width: 130px;\n      }\n      @media screen and (max-width: 1400px) {\n        max-width: 120px;\n      }\n    }\n\n\n    .nameCol {\n      min-width: 100px;\n\n      .nameColContent {\n        text-overflow: ellipsis;\n        overflow: hidden;\n        white-space: nowrap;\n      }\n    }\n  }\n\n  .addRowBtn {\n    margin-top: 16px;\n    width: 100%;\n\n    background: #91DAD3 !important;\n    color: #00A899;\n  }\n}\n\n.TargetShowcase::-webkit-scrollbar {\n  width: 4px;\n  height: 4px;\n}\n\n.TargetShowcase::-webkit-scrollbar-thumb {\n  background-color: #04867a;\n  border-radius: 50px;\n}\n\n.TargetShowcase::-webkit-scrollbar-track {\n  background: #e2e4e7;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"TargetShowcase": `TargetShowcase_TargetShowcase__rLeVE`,
	"content": `TargetShowcase_content__+AhSq`,
	"nameCol": `TargetShowcase_nameCol__j-6Eo`,
	"nameColContent": `TargetShowcase_nameColContent__7qMq8`,
	"addRowBtn": `TargetShowcase_addRowBtn__R9EtY`
};
export default ___CSS_LOADER_EXPORT___;
